import React from 'react';

import {
  MASK_CHAR, resolveSortCode, useBankDetailsFieldIntent, VALUE_CHAR,
} from '../AddBankDetails.helpers';

import { AddBankDetailsField } from './helpers/AddBankDetailsField';
import { useMaskField } from './helpers/AddBankDetailsHooks';

export const ACCOUNT_SORT_CODE_FIELD_NAME = 'sortCode';
export const ACCOUNT_SORT_CODE_DEFAULT_FORMAT = `${VALUE_CHAR.repeat(2)}-${VALUE_CHAR.repeat(2)}-${VALUE_CHAR.repeat(2)}`;
export const ACCOUNT_SORT_CODE_MASKED_FORMAT = `${MASK_CHAR.repeat(4)}${VALUE_CHAR.repeat(2)}`;

export const SortCode = () => {
  const { format, onInputFocus } = useMaskField(ACCOUNT_SORT_CODE_FIELD_NAME, {
    defaultFormat: ACCOUNT_SORT_CODE_DEFAULT_FORMAT,
    maskedFormat: ACCOUNT_SORT_CODE_MASKED_FORMAT,
    valueResolver: resolveSortCode,
  });

  const intent = useBankDetailsFieldIntent(ACCOUNT_SORT_CODE_FIELD_NAME);

  return (
    <AddBankDetailsField
      {...{ intent, onInputFocus }}
      inputProps={{
        format,
        mask: '_',
      }}
      name={ACCOUNT_SORT_CODE_FIELD_NAME}
    />
  );
};
